export enum OrderStatusVolume {
  TradingVolume = 1,
  PartiallyAcceptedVolume = 2,
  RejectedVolume = 3,
  AwaitingTransportInformation = 4,
  RemainingVolumeCanceled = 5,
  CompletedVolume = 6,
  ShippedVolume = 7,
  TradingVolumeViaAutopilot = 8,
  AwaitingTransportInformationViaAutopilot = 9,
  RejectedAndRedistributedVolume = 11,
}

export enum TIPO_NEGOCIACAO_VOLUME {
  VOLUME_NEGOCIACAO = 2,
  VOLUME_ACEITO_PARCIALMENTE = 3,
  AGUARDANDO_CONFIRMACAO_RECUSA_AMBEV = 4,
  VOLUME_RECUSADO = 5,
  AGUARDANDO_CONFIRMACAO_ACEITE_PARCIAL_AMBEV = 10,
  VOLUME_PEDIDO_ATUALIZADO = 13,
  VOLUME_NEGOCIACAO_VIA_AUTOPILOT = 14,
  VOLUME_REDISTRIBUIDO_DELTA = 17,
};